export class DTReelSymbolName {
    public static readonly STACK_WILD: string = "W0";
    public static readonly MYSTERY: string = "M";
}